import { z } from 'zod'
import { moneyAmountSchema } from '../validators/money.validator.js'
import { uuidSchema } from '../validators/uuid.validator.js'
import { proposalPlanSchema } from '../enums/proposal-plan.enum.js'

/**
 * An accepted proposal with work left for later: next season's sales.
 *
 * The trees a board deferred are already surveyed and priced, so the figure
 * here is a quote waiting to be sent again, not a guess.
 */
export const proposalFollowUpDtoSchema = z.object({
  proposalId: uuidSchema,
  versionId: uuidSchema,
  title: z.string(),
  clientId: uuidSchema,
  clientName: z.string(),
  ownerName: z.string().nullable(),
  /** The plan they accepted. PHASED means the deferred work was planned. */
  plan: proposalPlanSchema.nullable(),
  acceptedAt: z.string().datetime(),
  acceptedAmount: moneyAmountSchema.nullable(),
  /** The work left for later, before tax. */
  deferredAmount: moneyAmountSchema,
})

export type ProposalFollowUpDto = z.infer<typeof proposalFollowUpDtoSchema>
